exports = module.exports = require("../../../../react/node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".tgH{font-family:Foco;color:#444;font-size:16px;line-height:1.5}.tgH.r3S{text-align:left}.tgH._1Bu{text-align:center}.tgH._1-m{text-align:right}.tgH._3w3{font-weight:100}.tgH._3E4{font-weight:600}", ""]);
// Exports
exports.locals = {
	"typography": "tgH",
	"left": "r3S",
	"center": "_1Bu",
	"right": "_1-m",
	"light": "_3w3",
	"bold": "_3E4"
};